import { defineEvent } from '../types/event';
export var HOMEPAGE_VIEW = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
